import { Component } from "react";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import { Card, Form, Row, Col, Input, Divider, Button } from "antd";
import { inject } from "mobx-react";
import { cloudBlogPreview } from "services/cloud";

const { TextArea } = Input;

@inject("rootStore")
@Form.create({
})
class CloudBlogForm extends Component {
    handlePreview = () => {
        this.props.form.validateFieldsAndScroll((err, vals) => {
            if (err != null) {
                return;
            }
            let payload = {
                bucketName: vals.bucketName,
                directory: vals.directory,
                title: vals.title,
                keywords: vals.keywords,
                description: vals.description,
                aboutMe: vals.aboutMe,
                contact: vals.contact,
                facebook: vals.facebook,
                instagram: vals.instagram,
                twitter: vals.twitter,
                linkedin: vals.linkedin,                
            }
            cloudBlogPreview(payload).then((res) => {
                console.log(res);
            });
        })
    }

    render() {
        return (
            <Form layout={"vertical"}>
                <Divider orientation="left">General Information</Divider>
                <Row>
                    <Col span={12} style={{ padding: 10 }}>
                        <Form.Item label="Bucket Name (should be in spintax)">
                            {this.props.form.getFieldDecorator("bucketName", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter bucket name"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col span={12} style={{ padding: 10 }}>
                        <Form.Item label="Directory">
                            {this.props.form.getFieldDecorator("directory", {
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Meta Tags</Divider>
                <Row>
                    <Col span={12} style={{ padding: 10 }}>
                        <Form.Item label="Title">
                            {this.props.form.getFieldDecorator("title", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter title of the blog"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12} style={{ padding: 10 }}>
                        <Form.Item label="Keywords">
                            {this.props.form.getFieldDecorator("keywords", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter some keywords for your blog"
                                    }
                                ]
                            })(<TextArea rows={5} />)}
                        </Form.Item>
                    </Col>
                    <Col span={12} style={{ padding: 10 }}>
                        <Form.Item label="Description">
                            {this.props.form.getFieldDecorator("description", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter description for your blog"
                                    }
                                ]
                            })(<TextArea rows={5} />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Special Pages</Divider>
                <Row>
                    <Col span={12} style={{ padding: 10 }}>
                        <Form.Item label="About me">
                            {this.props.form.getFieldDecorator("aboutMe", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter content for the about me page"
                                    }
                                ]
                            })(<TextArea rows={10} />)}
                        </Form.Item>
                    </Col>
                    <Col span={12} style={{ padding: 10 }}>
                        <Form.Item label="Contact">
                            {this.props.form.getFieldDecorator("contact", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter content for the contact us page"
                                    }
                                ]
                            })(<TextArea rows={10} />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Social Profiles</Divider>
                <Row>
                    <Col span={6} style={{ padding: 10 }}>
                        <Form.Item label="Facebook">
                            {this.props.form.getFieldDecorator("facebook", {})
                                (<Input />)}
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ padding: 10 }}>
                        <Form.Item label="Instagram">
                            {this.props.form.getFieldDecorator("instagram", {})
                                (<Input />)}
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ padding: 10 }}>
                        <Form.Item label="Twitter">
                            {this.props.form.getFieldDecorator("twitter", {})
                                (<Input />)}
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ padding: 10 }}>
                        <Form.Item label="LinkedIn">
                            {this.props.form.getFieldDecorator("linkedin", {})
                                (<Input />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Button type="primary" style={{ marginRight: 20 }} onClick={this.handlePreview}>Preview</Button>
                    <Button type="primary" >Upload</Button>
                </Row>
            </Form>
        )
    }
}

class CloudBlogGeneratorPage extends Component {
    render() {
        let breadcrumbList = "";
        return (
            <PageHeaderLayout
                breadcrumbList={breadcrumbList}
                title={"Cloud Blog Generator"}
            >
                <Card>
                    <CloudBlogForm />
                </Card>
            </PageHeaderLayout>
        )
    }
}
export default CloudBlogGeneratorPage;